module.exports = __webpack_public_path__ + "static/img/安全教育网站-2.e86b2d7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/安全教育网站-2.png
// module id = G0/3
// module chunks = 13